import React, { useEffect, useState } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectTab, setIsExamLaunched } from '../../store/actions/index';

import { useLocation } from 'react-router-dom';
import { getMenuItem } from './Helper';
import { setReRegistrationsReload } from '../../store/actions';

const SideBar = (props) => {
    const [count, setCount] = useState(0);
    const { pathname } = useLocation();
    const history = useHistory();

    let currentTabValue = pathname.split('/');
    const notificationcount = useSelector((state) => state.notification);
    const ticketNotification = useSelector((state) => state.ticketNotification);
    const chatNotification = useSelector((state) => state.chatNotification);
    const courseCount = useSelector((state) => state.course);

    const selectorState = useSelector((state) => state);
    const filesRequired = useSelector((state) => state.registrations.filesRequired);
    const reload = useSelector((state) => state.registrations.reload);
    const reregData = useSelector((state) => state.registrations.data);
    const { user, reRegistrationCount, isReReg, isWithHeld, isExamReg, pmcReregData, isArticulation } = selectorState;
    const dispatch = useDispatch();
    const checkMissingKey = useSelector((state) => state.missingDetail.missingDetail);
    const [currentTab, setCurrentTab] = useState(1);
    const examReg = localStorage.getItem('examReg');
    const reReg = localStorage.getItem('reReg');
    const tabId = useSelector((state) => state.tabs.tab);
    const [reRegCount, setReRegCount] = useState('');
    const { examLaunched } = useSelector((state) => state.examLaunched);

    const isExamLaunched = history.location.pathname === examLaunched?.url && examLaunched?.isExamLaunched;
    const examPopup = () => dispatch(setIsExamLaunched({ ...examLaunched, isClicked: true }));

    useEffect(() => {
        setCount(courseCount.currentCount);
    }, [props.count]);

    var Tabs = [
        {
            name: 'Home',
            class: 'fa-house',
            refLink: 'requiredStudentDetails',
            id: 12,
        },
        {
            name: 'Home',
            class: 'fa-house',
            refLink: 'ResultWithheld',
            id: 14,
        },
        {
            name: 'Home',
            class: 'fa-house',
            refLink: 'examregistration',
            id: 15,
        },
        {
            name: 'Home',
            class: 'fa-house',
            refLink: 'reregStatus',
            id: 13,
        },
        {
            name: 'Home',
            class: 'fa-house',
            refLink: 'status',
            id: 0,
        },
        {
            name: 'Home',
            class: 'fa-house',
            refLink: 'home',
            id: 1,
        },
        {
            name: 'My Profile',
            class: 'fa-user',
            refLink: 'profile',
            id: 2,
        },
        {
            name: 'My Courses',
            class: 'fa-books',
            refLink: 'mycourses',
            id: 4,
        },

        {
            name: 'Notifications',
            class: 'fa-bell',
            refLink: 'mynotifications',
            id: 6,
        },
        {
            name: 'Calendar',
            class: 'fa-calendar-days',
            refLink: 'calendar',
            id: 10,
        },

        {
            name: 'Exam Registration',
            class: 'fa-clipboard',
            refLink: 'myexam',
            id: 8,
        },
        {
            name: 'Applications',
            class: 'fa-file-pen',
            refLink: 'reregistration',
            id: 9,
        },
        {
            name: 'My Tickets',
            class: 'fa-ticket-simple',
            refLink: 'mytickets',
            id: 5,
        },
        {
            name: 'Student Hub',
            class: 'fa-circle-info',
            refLink: `student-hub`,
            id: 11,
        },
    ];

    const nated = Array.isArray(reregData)
        ? reregData.some((item) => item.nated === 1)
        : Array.isArray(reregData?.open) && reregData.open.some((item) => item.nated === 1);

    const ArticulationStatus = isArticulation.isArticulation;
    const reRegStatus = isReReg?.isReReg ?? false;
    const examRegStatus = isExamReg?.isExamReg ?? false;
    const isPmcReRegSoftLaunch = (isReReg?.pmcReregData && isReReg?.pmcReregData.length > 0) ?? false;
    const isWithHeldStatus = localStorage.getItem('isResultWitheld');
    if (
        currentTabValue.length === 2 &&
        currentTabValue[1] === 'reregistration' &&
        (!reRegStatus || user.status == 'Results Witheld') &&
        !reReg &&
        user.status !== 'On Hold'
    ) {
        history.push('/reregStatus');
    }
    return (
        <>
            <div className="sidebar-left">
                <ul className="list-unstyled side-bar-nav m-0">
                    {Tabs.map((tab, index) => {
                        if (
                            tab.id === 13 &&
                            !checkMissingKey &&
                            (reRegStatus || isPmcReRegSoftLaunch) &&
                            user.status != 'Results Witheld' &&
                            user.status !== 'On Hold' &&
                            isWithHeldStatus != 'true'
                        ) {
                            return (
                                <li
                                    title={
                                        tab.id === 13
                                            ? 'Student Portal Home'
                                            : 'Log and track your tickets with the AIE support team'
                                    }
                                    key={tab.id}
                                    onClick={() => {
                                        dispatch(setReRegistrationsReload(!reload));
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }));
                                    }}
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            className={tab.refLink === getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id === 5 && ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink === getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id === 5 && ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            tab.id == 16 &&
                            !user.status != 'On Hold' &&
                            !checkMissingKey &&
                            (!reRegStatus || user.status == 'Results Witheld') &&
                            isWithHeldStatus != 'true' &&
                            !examRegStatus &&
                            !isPmcReRegSoftLaunch
                        ) {
                            return <> </>;
                        } else if (
                            tab.id === 15 &&
                            !checkMissingKey &&
                            examRegStatus &&
                            ((!isPmcReRegSoftLaunch && !reRegStatus) || user.status == 'Results Witheld') &&
                            user.status !== 'On Hold' &&
                            isWithHeldStatus != 'true'
                        ) {
                            return (
                                <li
                                    title={
                                        tab.id === 15
                                            ? 'Student Portal Home'
                                            : 'Log and track your tickets with the AIE support team'
                                    }
                                    key={tab.id}
                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            className={tab.refLink === getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id === 5 && ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink === getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id === 5 && ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            tab.id === 9 &&
                            !checkMissingKey &&
                            (reRegStatus || isPmcReRegSoftLaunch) &&
                            user.status !== 'On Hold' &&
                            currentTabValue.length === 3 &&
                            isWithHeldStatus != 'true'
                        ) {
                            return (
                                <li
                                    title="Your Applications"
                                    key={tab.id}
                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {filesRequired == 1 && <small className="notify-count">1</small>}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {filesRequired == 1 && <small className="notify-count">1</small>}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        }
                        if (tab.id == 5) {
                            if (user.status === 'On Hold') {
                                return (
                                    <li
                                        title="Log and track your tickets with the AIE support team"
                                        key={tab.id}
                                        onClick={() =>
                                            isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                        }
                                    >
                                        {isExamLaunched ? (
                                            <Link
                                                className={
                                                    tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''
                                                }
                                            >
                                                <span className="nav-icon">
                                                    {ticketNotification.ticketnotificationcount > 0 && (
                                                        <small className="notify-count">
                                                            {ticketNotification.ticketnotificationcount > 9
                                                                ? '9+'
                                                                : ticketNotification.ticketnotificationcount}
                                                        </small>
                                                    )}

                                                    <i className={'fa-light fa-fw ' + tab.class}></i>
                                                </span>
                                                {tab.name}
                                            </Link>
                                        ) : (
                                            <NavLink
                                                to={('/', '/' + tab.refLink)}
                                                className={
                                                    tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''
                                                }
                                            >
                                                <span className="nav-icon">
                                                    {ticketNotification.ticketnotificationcount > 0 && (
                                                        <small className="notify-count">
                                                            {ticketNotification.ticketnotificationcount > 9
                                                                ? '9+'
                                                                : ticketNotification.ticketnotificationcount}
                                                        </small>
                                                    )}

                                                    <i className={'fa-light fa-fw ' + tab.class}></i>
                                                </span>
                                                {tab.name}
                                            </NavLink>
                                        )}
                                    </li>
                                );
                            }

                            return (
                                <li
                                    title="Log and track your tickets with the AIE support team"
                                    key={tab.id}

                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            tab.id == 0 &&
                            user.status == 'On Hold' &&
                            !checkMissingKey &&
                            isWithHeldStatus != 'true' &&
                            user.status != 'Results Witheld'
                        ) {
                            return (
                                <li
                                    title={
                                        tab.id == 0
                                            ? 'Student Portal Home'
                                            : 'Log and track your tickets with the AIE support team'
                                    }
                                    key={tab.id}

                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id == 5 && ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id == 5 && ticketNotification.ticketnotificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {ticketNotification.ticketnotificationcount > 9
                                                            ? '9+'
                                                            : ticketNotification.ticketnotificationcount}
                                                    </small>
                                                )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (tab.id == 12 && checkMissingKey && isWithHeldStatus != 'true' && !examRegStatus) {
                            return (
                                <li
                                    title={tab.id == 12 ? 'Student Portal Home' : ''}
                                    key={tab.id}

                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {' '}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {' '}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (tab.id == 14 && !checkMissingKey && isWithHeldStatus == 'true' && !examRegStatus) {
                            return (
                                <li
                                    title={tab.id == 14 ? 'Student Portal Home' : ''}
                                    key={tab.id}

                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {' '}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {' '}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            tab.id == 6 &&
                            user.status != 'On Hold' &&
                            !checkMissingKey &&
                            (!reRegStatus || user.status == 'Results Witheld') &&
                            isWithHeldStatus != 'true' &&
                            !examRegStatus &&
                            !isPmcReRegSoftLaunch
                        ) {
                            return (
                                <li
                                    title="Get important information of direct interest to you and your studies"
                                    key={tab.id}

                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {notificationcount.notificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {notificationcount.notificationcount > 9
                                                            ? '9+'
                                                            : notificationcount.notificationcount}
                                                    </small>
                                                )}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {notificationcount.notificationcount > 0 && (
                                                    <small className="notify-count">
                                                        {notificationcount.notificationcount > 9
                                                            ? '9+'
                                                            : notificationcount.notificationcount}
                                                    </small>
                                                )}
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            tab.id < 8 &&
                            tab.id != 0 &&
                            tab.id != 6 &&
                            user.status != 'On Hold' &&
                            !checkMissingKey &&
                            (!reRegStatus || user.status == 'Results Witheld') &&
                            isWithHeldStatus != 'true' &&
                            !examRegStatus &&
                            !isPmcReRegSoftLaunch
                        ) {
                            return (
                                <li
                                    title={
                                        tab.id == 1
                                            ? 'Student Portal Home'
                                            : tab.id == 2
                                              ? 'Always keep your student profile up to date'
                                              : tab.id == 4
                                                ? 'All your important course information for easy study'
                                                : null
                                    }
                                    key={tab.id}

                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id == 4 &&
                                                    chatNotification.chatnotificationcount.newsRoomUnreadMessageCount -
                                                        count >
                                                        0 && (
                                                        <small className="notify-count">
                                                            {chatNotification.chatnotificationcount
                                                                .newsRoomUnreadMessageCount -
                                                                count >
                                                            9
                                                                ? '9+'
                                                                : chatNotification.chatnotificationcount
                                                                      .newsRoomUnreadMessageCount - count}
                                                        </small>
                                                    )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                {tab.id == 4 &&
                                                    chatNotification.chatnotificationcount.newsRoomUnreadMessageCount -
                                                        count >
                                                        0 && (
                                                        <small className="notify-count">
                                                            {chatNotification.chatnotificationcount
                                                                .newsRoomUnreadMessageCount -
                                                                count >
                                                            9
                                                                ? '9+'
                                                                : chatNotification.chatnotificationcount
                                                                      .newsRoomUnreadMessageCount - count}
                                                        </small>
                                                    )}

                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            (tab.id == 8 || tab.id == 9) &&
                            user.status != 'On Hold' &&
                            !checkMissingKey &&
                            isWithHeldStatus != 'true'
                        ) {
                            if (
                                tab.id == 8 &&
                                ((reRegStatus && nated) ||
                                    ((examReg == 'true' || examReg == true) &&
                                        (examRegStatus ||
                                            ((!reRegStatus || user.status == 'Results Witheld') &&
                                                !examRegStatus &&
                                                !isPmcReRegSoftLaunch))))
                            ) {
                                return (
                                    <li
                                        title="Your Exam Registrations"
                                        key={tab.id}

                                        onClick={() =>
                                            isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                        }
                                    >
                                        {isExamLaunched ? (
                                            <Link
                                                to="#"
                                                className={
                                                    tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''
                                                }
                                            >
                                                <span className="nav-icon">
                                                    <i className={'fa-light fa-fw ' + tab.class}></i>
                                                </span>
                                                {tab.name}
                                            </Link>
                                        ) : (
                                            <NavLink
                                                to={('/', '/' + tab.refLink)}
                                                className={
                                                    tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''
                                                }
                                            >
                                                <span className="nav-icon">
                                                    <i className={'fa-light fa-fw ' + tab.class}></i>
                                                </span>
                                                {tab.name}
                                            </NavLink>
                                        )}
                                    </li>
                                );
                            } else if (
                                tab.id == 9 &&
                                user.status != 'On Hold' &&
                                !checkMissingKey &&
                                isWithHeldStatus != 'true' &&
                                (reReg == true || reReg == 'true') &&
                                (((reRegStatus || isPmcReRegSoftLaunch) && !ArticulationStatus) ||
                                    (((!reRegStatus && !isPmcReRegSoftLaunch) || user.status == 'Results Witheld') &&
                                        !examRegStatus))
                            ) {
                                //
                                return (
                                    <li
                                        title="Your Applications"
                                        key={tab.id}

                                        onClick={() =>
                                            isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                        }
                                    >
                                        {isExamLaunched ? (
                                            <Link
                                                to="#"
                                                className={
                                                    tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''
                                                }
                                            >
                                                <span className="nav-icon">
                                                    {filesRequired == 1 && <small className="notify-count">1</small>}
                                                    <i className={'fa-light fa-fw ' + tab.class}></i>
                                                </span>
                                                {tab.name}
                                            </Link>
                                        ) : (
                                            <NavLink
                                                to={('/', '/' + tab.refLink)}
                                                className={
                                                    tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''
                                                }
                                            >
                                                <span className="nav-icon">
                                                    {filesRequired == 1 && <small className="notify-count">1</small>}
                                                    <i className={'fa-light fa-fw ' + tab.class}></i>
                                                </span>
                                                {tab.name}
                                            </NavLink>
                                        )}
                                    </li>
                                );
                            }
                        } else if (
                            tab.id == 10 &&
                            user.status != 'On Hold' &&
                            !checkMissingKey &&
                            (!reRegStatus || user.status == 'Results Witheld') &&
                            isWithHeldStatus != 'true' &&
                            !examRegStatus &&
                            !isPmcReRegSoftLaunch
                        ) {
                            return (
                                <li
                                    title="All your important dates in one location"
                                    key={tab.id}
                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        } else if (
                            tab.id == 11 &&
                            user.status != 'On Hold' &&
                            !checkMissingKey &&
                            (!reRegStatus || user.status == 'Results Witheld') &&
                            isWithHeldStatus != 'true' &&
                            !examRegStatus &&
                            !isPmcReRegSoftLaunch
                        ) {
                            return (
                                <li
                                    title="Access academic resources, policies, library and how-to guides here"
                                    key={tab.id}
                                    onClick={() =>
                                        isExamLaunched ? examPopup() : dispatch(selectTab({ tab: tab.id }))
                                    }
                                >
                                    {isExamLaunched ? (
                                        <Link
                                            to="#"
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </Link>
                                    ) : (
                                        <NavLink
                                            to={('/', '/' + tab.refLink)}
                                            className={tab.refLink == getMenuItem(currentTabValue[1]) ? 'active' : ''}
                                        >
                                            <span className="nav-icon">
                                                <i className={'fa-light fa-fw ' + tab.class}></i>
                                            </span>
                                            {tab.name}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        }
                    })}
                </ul>
            </div>
        </>
    );
};

export default SideBar;
